import React from 'react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  dark?: boolean;
};
export function SectionCTA({
  label,
  dark = false
}: SectionCTAProps) {
  return <div className="mt-10 flex flex-col items-center gap-2.5" data-id="element-52" data-mp="1ld3d51r5ib1d">
      <CTAButton label={label} sublabel="Complete system · Only $27" size="md" data-id="element-53" data-mp="1lcl5za2yaceo" />
      <p className={`text-xs font-medium ${dark ? 'text-white/70' : 'text-navy/60'}`} data-id="element-54" data-mp="1qaczu9n5o8li">Instant access · One-time payment · 7-day guarantee</p>
    </div>;
}